import React from "react";
import { ControlContainer } from "./CameraControl.style";
import { Card } from "antd";
import { ReactComponent as EarthIcon } from "../../../assets/svgs/icons/earth-icon.svg";
import { ReactComponent as FlyIcon } from "../../../assets/svgs/icons/fly-icon.svg";
import { ReactComponent as HelicopterIcon } from "../../../assets/svgs/icons/helicopter-icon.svg";
import { ReactComponent as OrbitIcon } from "../../../assets/svgs/icons/orbic-icon.svg";
import { ReactComponent as FullIcon } from "../../../assets/svgs/icons/full-icon.svg";
import { ReactComponent as NavigationIcon } from "../../../assets/svgs/icons/navigation-icon.svg";
import { ReactComponent as CompassIcon } from "../../../assets/svgs/icons/compass-icon.svg";
import { cameraControlPotreeFunc } from "./cameraControlsUtils";

const buttons = [
  { id: 1, Icon: EarthIcon, label: "Earth Control",           callback: () => { cameraControlPotreeFunc.setControls('Earth') } },
  { id: 2, Icon: FlyIcon, label: "Fly Measurement",           callback: () => { cameraControlPotreeFunc.setControls('Fly')} },
  { id: 3, Icon: HelicopterIcon, label: "Helicopter Control", callback: () => { cameraControlPotreeFunc.setControls('Helicopter')} },
  { id: 4, Icon: OrbitIcon, label: "Orbit Control",           callback: () => { cameraControlPotreeFunc.setControls('Orbit')} },
  { id: 5, Icon: FullIcon, label: "Full Extent",              callback: cameraControlPotreeFunc.fullExtent},
  // { id: 6, Icon: NavigationIcon, label: "Navigation Cube",    callback: cameraControlPotreeFunc.toggleNavigationCube},
  { id: 7, Icon: CompassIcon, label: "Compass",               callback: cameraControlPotreeFunc.toggleCompass},
];

export default function CameraControl() {
  return (
    <>
      <ControlContainer>
      <div className="control_sections">
          <Card bordered={false} style={{ width: 200 }}>
            <div className="control_sections-container">
              {buttons.map((button, index) => (
                <div key={button.id} className="control_sections-button" onClick={button?.callback}>
                  <button
                    type="button"
                    className={`control_addButton${
                      index === 0 ? " no-border-top" : ""
                    }`}
                  >
                    <button.Icon className="control_icon" />
                    {button.label}
                  </button>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </ControlContainer>
    </>
  );
}
